import React from 'react';

import {api} from "./baseFunctions";

import Right from "./Right";
import Panel from "./Panel";
import FormItem from "./FormItem";

export default class InboxPage extends React.Component {
  constructor(){
    super();
    this.sendMessage = this.sendMessage.bind(this);
    this.state = {
      allUsers: [],
      firms: {}
    };
  }
  componentDidMount()
  {
    api("POST", {"type": "allUsers"}, (d) => {
      console.log(d);
      if(!d.error)
      {
        let newFirms = {};
        d.firms.map((d) => {
          newFirms[d.id] = d.name;
        });
        this.setState({
          allUsers: d.users,
          firms: newFirms
        });
      }
    }, this.props.auth, 1);
  }
  sendMessage(e)
  {
    e.preventDefault();
    console.log(this.refs);
    let otherPhones = [...this.refs.otherPhone.options].filter((d) => d.selected).filter((d) => d.value.length > 0).map((d) => d.value);
 
    api("POST", {"type": "sendSms", data: {number: this.refs.number.value, msg: this.refs.msg.value, list: otherPhones}}, (d) => {
      console.log(d);
      if(!d.error)
      {
        alert("Beskeden er blevet afsendt!");
      }else{
        alert("Gateway error: " + d.msg);
        this.refs.msg.value = "The following numbers failed!:\n" + JSON.stringify(d.failedNumbers);
      }
    }, this.props.auth, 1);
  }

	render(){
    const RANKS = {
      "-1": "Superadmin",
      "0": "Admin",
      "1": "Bruger"
    }
		return (
    <Right>
      <Panel title="Send SMS">
        <form onSubmit={this.sendMessage}>
          <FormItem name="Nummer" must={1}>
            <input type="phone" className="form-control col-md-7 col-xs-12" ref="number"/>
            <select ref="otherPhone" multiple={true} className="form-control col-md-7 col-xs-12" style={{height: "500px"}}>
              {
                this.state.allUsers.map((d, key) => <option key={"usr" + key} value={d.phone}>[{this.state.firms[d.firm]}][{RANKS[d.rank]}] #{d.id} {d.phone} {d.name}</option>)
              }
            </select>
          </FormItem>
          <FormItem name="Besked" must={1}>
            <textarea type="text" required={true} className="form-control col-md-7 col-xs-12" ref="msg"/>
          </FormItem>
          <FormItem name="">
            <button type="submit" className="btn btn-success">Send besked</button>
          </FormItem>
      </form>
      </Panel>
    </Right>);
	}
}



// WEBPACK FOOTER //
// ./src/components/SmsPage.js